export default __webpack_public_path__ + "static/media/illustrasjoner14.cd7211fd.png";